import User from "./User" ;
import DateTime from "../core/DateTime" ;
import DBObject from "../utils/DBObject" ;
import CloneContext from "../utils/CloneContext" ;


  export default  class  CallHistoriesRequest extends  DBObject {  private static readonly _FROMDATE: number = 0 ;
  private static readonly _OFFSET: number = 1 ;
  private static readonly _PAGESIZE: number = 2 ;
  private static readonly _TODATE: number = 3 ;
  private static readonly _USER: number = 4 ;
  public id: number = 0 ;
  public otherMaster: DBObject ;
  private _user: User = null ;
  private _pageSize: number = 0 ;
  private _offset: number = 0 ;
  private _toDate: DateTime = null ;
  private _fromDate: DateTime = null ;
 public constructor ( d3eParams ? : Partial<{fromDate: DateTime, offset: number, pageSize: number, toDate: DateTime, user: User}> ) {
 super();

this.setFromDate(d3eParams?.fromDate ?? null);

this.setOffset(d3eParams?.offset ?? 0);

this.setPageSize(d3eParams?.pageSize ?? 0);

this.setToDate(d3eParams?.toDate ?? null);

this.setUser(d3eParams?.user ?? null);
 }
  public get d3eType (  ) : string {
 return 'CallHistoriesRequest' ; 
 }
  public clear (  ) : void {
 this.d3eChanges.clear();
 }
  public get isTransientModel (  ) : boolean {
 return ; 
 }
  public get user (  ) : User {
 return this._user ; 
 }
  public setUser ( val : User ) : void {
 let isValChanged :boolean=this._user !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(CallHistoriesRequest._USER,this._user);

this.updateObservable('user',this._user,val);

this._user=val;

this.fire('user',this);
 }
  public get pageSize (  ) : number {
 return this._pageSize ; 
 }
  public setPageSize ( val : number ) : void {
 let isValChanged :boolean=this._pageSize !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(CallHistoriesRequest._PAGESIZE,this._pageSize);

this._pageSize=val;

this.fire('pageSize',this);
 }
  public get offset (  ) : number {
 return this._offset ; 
 }
  public setOffset ( val : number ) : void {
 let isValChanged :boolean=this._offset !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(CallHistoriesRequest._OFFSET,this._offset);

this._offset=val;

this.fire('offset',this);
 }
  public get toDate (  ) : DateTime {
 return this._toDate ; 
 }
  public setToDate ( val : DateTime ) : void {
 let isValChanged :boolean=this._toDate !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(CallHistoriesRequest._TODATE,this._toDate);

this._toDate=val;

this.fire('toDate',this);
 }
  public get fromDate (  ) : DateTime {
 return this._fromDate ; 
 }
  public setFromDate ( val : DateTime ) : void {
 let isValChanged :boolean=this._fromDate !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(CallHistoriesRequest._FROMDATE,this._fromDate);

this._fromDate=val;

this.fire('fromDate',this);
 }
  public get ( field : number ) : any {
 switch ( field ) {
 case CallHistoriesRequest._USER : {
 return this._user ; 
 }

case CallHistoriesRequest._PAGESIZE : {
 return this._pageSize ; 
 }

case CallHistoriesRequest._OFFSET : {
 return this._offset ; 
 }

case CallHistoriesRequest._TODATE : {
 return this._toDate ; 
 }

case CallHistoriesRequest._FROMDATE : {
 return this._fromDate ; 
 }
 default: {
 return null ; 
 }
 }
 }
  public updateD3EChanges ( index : number,value : any ) : void {
 if ( this.lockedChanges() ) {
 return ; 
 }

super.updateD3EChanges(index,value);
 }
  public restore (  ) : void {
 /*
TODO: Might be removed
*/

this.d3eChanges.restore(this);
 }
  public deepClone ( clearId = true ) : CallHistoriesRequest {
 let ctx :CloneContext=new CloneContext({ 'clearId':clearId });

return ctx.startClone(this) ; 
 }
  public collectChildValues ( ctx : CloneContext ) : void {
  }
  public deepCloneIntoObj ( dbObj : DBObject,ctx : CloneContext ) : void {
 let obj :CallHistoriesRequest=( dbObj as CallHistoriesRequest );

obj.id=this.id;

obj.setUser(this._user);

obj.setPageSize(this._pageSize);

obj.setOffset(this._offset);

obj.setToDate(this._toDate);

obj.setFromDate(this._fromDate);
 }
  public set ( field : number,value : any ) : void {
 switch ( field ) {
 case CallHistoriesRequest._USER : {
 this.setUser(( value as User ));
 break; }

case CallHistoriesRequest._PAGESIZE : {
 this.setPageSize(( value as number ));
 break; }

case CallHistoriesRequest._OFFSET : {
 this.setOffset(( value as number ));
 break; }

case CallHistoriesRequest._TODATE : {
 this.setToDate(( value as DateTime ));
 break; }

case CallHistoriesRequest._FROMDATE : {
 this.setFromDate(( value as DateTime ));
 break; }
 }
 }
 }